/* Generic admin CRUD utilities. */
import api from "@/lib/api";
import React, { useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";

export function AdminPageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-center justify-between mb-5 flex-wrap gap-2">
      <div>
        <h1 className="text-2xl font-black">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Field({ label, ...rest }) {
  return (
    <div>
      <label className="block text-xs font-medium mb-1 text-gray-600">{label}</label>
      <input {...rest} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm" />
    </div>
  );
}

export function TextArea({ label, ...rest }) {
  return (
    <div>
      <label className="block text-xs font-medium mb-1 text-gray-600">{label}</label>
      <textarea {...rest} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm"></textarea>
    </div>
  );
}

export function Select({ label, options = [], ...rest }) {
  return (
    <div>
      <label className="block text-xs font-medium mb-1 text-gray-600">{label}</label>
      <select {...rest} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm">
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

export function Toggle({ label, value, onChange, ...rest }) {
  return (
    <label className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 accent-[#e11d2a]"
        {...rest}
      />
      <span className="text-sm">{label}</span>
    </label>
  );
}

export function ConfirmDeleteButton({ onConfirm, label = "Sil" }) {
  return (
    <button onClick={() => { if (window.confirm("Silmek istediğinizden emin misiniz?")) onConfirm(); }} className="text-red-600 hover:text-red-700" title={label}><Trash2 className="w-4 h-4" /></button>
  );
}
